// extracted by mini-css-extract-plugin
export default {"PostDetailRight__searchPanel":"qh_a bhh_su bhh_kv bhh_kw","PostDetailRight__brandDaysPosts":"qh_b bhh_su bhh_kv bhh_kw"};